import { useChatMembers as useSharedChatMembers } from '@zealot/ui/hooks/useChatMembers';
import { useApiClient } from '@/contexts/ApiClientContext';

type UseChatMembersOptions = {
  search?: string;
  page?: number;
  pageSize?: number;
  enabled?: boolean;
};

export const useChatMembers = (options: UseChatMembersOptions = {}) => {
  const client = useApiClient();
  return useSharedChatMembers(client, options);
};
